var $f9e155e6e8cacaa2$exports = {};
$f9e155e6e8cacaa2$exports = {
    "Empty": `\u{5E8}\u{5D9}\u{5E7}`
};


export {$f9e155e6e8cacaa2$exports as default};
//# sourceMappingURL=he-IL.mjs.map
